/* global $ */

import Component from '../../js/lib/component';

const classList = {
  root: '.js-view',
  button: '.js-view-button'
};

export default class View extends Component {
  init() {
    const $active = this.$.button.filter('.is-active');
    const type = $active.data('type');

    this.setState({ type });
  }
  events() {
    this.$.button.on('click', e => {
      const $target = $(e.currentTarget);
      const type = $target.data('type');

      if (this.state.inprocess || $target.is('.is-active')) return;

      e.stopPropagation();

      this.lock();
      this.$.root.trigger('view.change', {
        type,
        toggle: this.toggle.bind(this, $target),
        unlock: this.unlock.bind(this)
      });
    });
  }
  toggle($target) {
    this.$.button.removeClass('is-active');
    $target.addClass('is-active');
  }
  lock() {
    this.setState({ inprocess: true });
  }
  unlock() {
    this.setState({ inprocess: false });
  }
}

Component.mount(View, {
  name: 'View',
  classList,
  state: {
    type: '',
    inprocess: false
  }
});
